import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';

import Isvg from 'react-inlinesvg';

import Slider from "react-slick";

import Range from 'rc-slider/lib/Range';
import Tooltip from 'rc-tooltip';

import 'rc-slider/assets/index.css';

import Switch from 'react-ios-switch';
import Dropzone from 'react-dropzone';
import GridLayout from 'react-grid-layout';
import { Editor } from '@tinymce/tinymce-react';


class AddProductPage extends Component {
    constructor(props) {
        super(props);
        this.onDrop = this.onDrop.bind(this);
        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.addProduct = this.addProduct.bind(this);
        this.removeImage = this.removeImage.bind(this);
        this.addColumn = this.addColumn.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        
        this.dropzone = React.createRef()

        this.state = {
            files: [],
            categories: [],
            columns: [],
            desktopColumnWidth: 6,
            mobileColumnWidth: 12,
            columnType: 'text'
        };
    }

    onLayoutChange(layout) {
        //console.log(layout);
        let arr = [];
        for (let i = 0; i < layout.length; i++) {
            arr.push({ idx: layout[i].i, position: layout[i].y * 12 + layout[i].x });
        }

        arr.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0); });
        console.log(arr);

        let columns = [];

        for(let i=0;i<this.state.columns.length;i++){
            columns.push(this.state.columns[parseInt(arr[i].idx)]);
        }
        this.setState({
            columns: columns
        });


        /*let imagesLayout = [];
        for (let i = 0; i < arr.length; i++) {
            imagesLayout.push(parseInt(arr[i].idx));
        }

        this.setState({
            imagesLayout: imagesLayout
        });*/

    }



    componentDidMount() {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }


    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('addProduct', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            if (data.error) {

            } else if (data.successful) {
                this.props[0].history.push(`/products`);
            }
        });

        this.props.socketIOClient.on('categories', (data) => {
            console.log(data);
            this.setState({
                categories: data
            });
        });



        this.props.socketIOClient.emit('categories', {});
    }


    addProduct() {
        let product = {
            title: this.state.title,
            alias: this.state.alias,
            category: this.state.category,
            status: this.state.status,
            imageBase64: this.state.files[0] ? this.state.files[0] : null,
            shortDescription: this.state.shortDescription,
            columns: this.state.columns
        }

        this.props.handleLoader(true);

        this.props.socketIOClient.emit("addProduct", product);
    }




    removeImage(idx) {
        let files = this.state.files.slice(0, idx).concat(this.state.files.slice(idx + 1, this.state.files.length))
        let imagesLayout = this.state.imagesLayout.slice(0, idx).concat(this.state.imagesLayout.slice(idx + 1, this.state.imagesLayout.length))

        this.setState({
            files: files,
            imagesLayout: imagesLayout,
        });
    }


    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("addProduct");
        this.props.socketIOClient.removeAllListeners("attributes");
        this.props.socketIOClient.removeAllListeners("categories");
    }

 
    removeImage() {

        this.setState({
            files: [],
        });
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result;
                resolve(encoded);
            };
            reader.onerror = error => reject(error);
        });
    }


    async onDrop(imageFiles) {
        let images = [];

        for (let i = 0; i < imageFiles.length; i++) {
            var base64Image = await this.getBase64(imageFiles[i]);
            images.push(base64Image);

        }

        this.setState({
            files: this.state.files.concat(images),
        })

    }


    addColumn() {
        let columns = this.state.columns;

        columns.push({
            desktopColumnWidth: this.state.desktopColumnWidth,
            mobileColumnWidth: this.state.mobileColumnWidth,
            columnType: this.state.columnType
        });

        this.setState({
            columns: columns
        });

    }

    

    removeItem(idx){
        let columns = this.state.columns;
        columns.splice(idx, 1);
        this.setState({
            columns: columns
        });
    }

    render() {

        let items = [];
        let layouts = [];


        let x = 0;
        let y = 0;
        for (let i = 0; i < this.state.columns.length; i++) {
            let layout = { i: i.toString(), x: x, y: y, w: parseInt(this.state.columns[i].desktopColumnWidth), h: 1 };
            let propBag = { 'data-grid': layout }
            let item = {
                content: (
                    <div key={i.toString()} className="grid-column-item" data-grid={layout}>
                        <i className="mdi mdi-delete" onClick={() => this.removeItem(i)}></i>
                        <div className="drag-handle"><i className="mdi mdi-cursor-move"></i></div>
                        {this.state.columns[i].columnType == 'text' ?
                            <Editor
                                apiKey="4cy398vgi6uz8lt6opj7pby71lhjbzyxe91wcuwlmyvhhze6"
                                init={{ plugins: 'link table', height: 200 }}
                                value={this.state.columns[i].value}
                                onEditorChange={(content) => { 
                                    let columns = this.state.columns;
                                    columns[i].value = content;
                                    this.setState({ columns: columns }) 
                                }}
                            />

                            :
                            <div className="image-drop">

                                <Dropzone
                                    onDrop={async (imageFiles) => {
                                        let columns = this.state.columns;
    
                                        var base64Image = await this.getBase64(imageFiles[0]);
                                        columns[i].value = base64Image;
                                
                                        this.setState({
                                            columns: columns
                                        });
                                
                                    }}
                                    className='dropzone'
                                    activeClassName='active-dropzone'
                                    multiple={false}>

                                    <button><i className="mdi mdi-file-outline"></i></button>


                                </Dropzone>

                                {this.state.columns[i].value ?
                                    <div className="preview">

                                        <img src={this.state.columns[i].value} />

                                    </div> : null

                                }
                            </div>
                        }

                    </div>
                )
            };
            layouts.push(layout);
            items.push(item);
            x += this.state.columns[i].desktopColumnWidth;
            if (x >= 12) {
                y++;
                x = 0;
            }
        }





        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel ">
                    <div className="panel-title">
                        <h1>{this.props.translate('Add new car')}</h1>
                        <h6>{this.props.translate('Fill fields to add car')}</h6>

                    </div>

                    <div>





                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Title')}</label>
                            <input type="text" value={this.state.title} onChange={(e) => { this.setState({ title: e.target.value, alias: this.props.generateAlias(e.target.value) }) }} />
                        </div>

                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Short description')}</label>
                            <input type="text" value={this.state.shortDescription} onChange={(e) => { this.setState({ shortDescription: e.target.value }) }} />
                        </div>


                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Alias')}</label>
                            <input type="text" value={this.state.alias} onChange={(e) => { this.setState({ alias: e.target.value }) }} />
                        </div>

                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Category')}</label>
                            <select value={this.state.category} onChange={(e) => { this.setState({ category: e.target.value });  }}>
                                <option>- - NONE - -</option>
                                {
                                    this.state.categories.map((category) => {
                                        return (
                                            <option value={category._id}>{category.name}</option>
                                        )
                                    }
                                    )}
                            </select>
                        </div>

                        <div className="input-wrap">
                            <label>{this.props.translate('Image')}</label>
                            <div className="file-drop" ref={(ref) => this.dropzone = ref}>

                                <Dropzone
                                    onDrop={this.onDrop}
                                    className='dropzone'
                                    activeClassName='active-dropzone'
                                    multiple={false}>

                                    <button><i className="mdi mdi-file-outline"></i></button>




                                </Dropzone>

                                {this.state.files.length ?
                                    <div className="preview">


                                        <img src={this.state.files[0]} />
                                        <div className='options'>
                                            <i className="mdi mdi-delete" onClick={() => this.removeImage()}></i>
                                        </div>


                                    </div> : null

                                }                        </div>
                        </div>



                        <div className="spacer"></div>


                        <div className="input-wrap input-wrap-3">
                            <label>{this.props.translate('Desktop column width')}</label>
                            <select value={this.state.desktopColumnWidth} onChange={(e) => { this.setState({ desktopColumnWidth: e.target.value }); }}>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                                <option value={6}>6</option>
                                <option value={7}>7</option>
                                <option value={8}>8</option>
                                <option value={9}>9</option>
                                <option value={10}>10</option>
                                <option value={11}>11</option>
                                <option value={12}>12</option>
                            </select>
                        </div>

                        <div className="input-wrap input-wrap-3">
                            <label>{this.props.translate('Mobile column width')}</label>
                            <select value={this.state.mobileColumnWidth} onChange={(e) => { this.setState({ mobileColumnWidth: e.target.value }); }}>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                                <option value={6}>6</option>
                                <option value={7}>7</option>
                                <option value={8}>8</option>
                                <option value={9}>9</option>
                                <option value={10}>10</option>
                                <option value={11}>11</option>
                                <option value={12}>12</option>
                            </select>
                        </div>

                        <div className="input-wrap input-wrap-3">
                            <label>{this.props.translate('Type')}</label>
                            <select value={this.state.columnType} onChange={(e) => { this.setState({ columnType: e.target.value }); }}>
                                <option value="text">Text</option>
                                <option value="image">Image</option>
                            </select>
                        </div>

                        <div className="input-wrap">
                            <button className="button" onClick={this.addColumn}>{this.props.translate('Add')}</button>
                        </div>



                        <div className="input-wrap" ref={(ref) => this.dropzone = ref}>
                            <label>{this.props.translate('Content')}</label>



                            <GridLayout
                                className="content-grid-layout"
                                onLayoutChange={this.onLayoutChange}
                                width={this.dropzone.offsetWidth}
                                draggableHandle={".drag-handle"}
                                rowHeight={400}
                                compactType={'horizontal'}
                                isResizable={false}
                                verticalCompact={true}
                                horizontalCompact={true}
                                layout={layouts}
                                useCSSTransforms={true}
                                cols={12}
                            >
                                {
                                    items.map((item, idx) => {
                                        return (
                                            item.content
                                        );
                                    })
                                }

                            </GridLayout>

                        </div>


                        <div className="input-wrap">

                            <label>{this.props.translate('Status')}</label>
                            <Switch className="react-switch"
                                checked={this.state.status}
                                handleColor="white"
                                offColor="rgb(204, 204, 204)"
                                onChange={() => { this.setState({ status: !this.state.status }) }}
                                onColor="rgb(146, 44, 136)"
                                pendingOffColor={undefined}
                                pendingOnColor={undefined}
                                readOnly={undefined}
                                style={undefined}
                            />

                        </div>


                        <div className="input-wrap">
                            <button className="button" onClick={this.addProduct}>{this.props.translate('Add')}</button>
                        </div>

                    </div>

                </div>

            </div>
        );
    }
}

export default PageWithLayout(AddProductPage);


// WEBPACK FOOTER //
// ./src/views/addProductPage.js